import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { DOCUMENT_LIST_FIELDS } from "../fragments/Document";
import {
  GetLatestVersionOfDocumentsByPermitRegisterId,
  GetLatestVersionOfDocumentsByPermitRegisterIdVariables,
} from "./__generated__/GetLatestVersionOfDocumentsByPermitRegisterId";

export const GET_LATEST_VERSION_OF_DOCUMENTS_BY_PERMIT_REGISTER_ID = gql`
  ${DOCUMENT_LIST_FIELDS}
  query GetLatestVersionOfDocumentsByPermitRegisterId(
    $permitRegisterId: String!
    $searchString: String
    $skip: Int
    $take: Int
    $typeId: String
  ) {
    latestVersionOfDocumentsByPermitRegisterId(
      permitRegisterId: $permitRegisterId
      searchString: $searchString
      skip: $skip
      take: $take
      typeId: $typeId
    ) {
      totalCount
      items {
        ...DocumentListFields
      }
    }
  }
`;

export function useLazyGetLatestVersionOfDocumentsByPermitRegisterId() {
  const [getLatestVersionOfDocumentsByPermitRegisterId, { loading, error, data, fetchMore, refetch }] = useLazyQuery<
    GetLatestVersionOfDocumentsByPermitRegisterId,
    GetLatestVersionOfDocumentsByPermitRegisterIdVariables
  >(GET_LATEST_VERSION_OF_DOCUMENTS_BY_PERMIT_REGISTER_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getLatestVersionOfDocumentsByPermitRegisterId,
    data,
    fetchMore,
    refetch,
    status: { loading, errors: getErrors(error), successful: !error && data ? true : false } as AsyncQueryStatus,
  };
}
